var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSend = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M19.82 11.49 4.32 4.2c-.16 0-.32.1-.32.3v5.693q0 .3.24.3L13 11.79l-8.76 1.3c-.16 0-.24.2-.24.3v5.692c0 .2.16.4.32.3l15.5-7.29c.24-.1.24-.5 0-.6"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgSend);
export default ForwardRef;